import { revealPopup } from './custom-popup';

function radioPopup() {
  $('.radio-holder.popup-trigger').on('click', function() {
    $(this).addClass('clicked');
    revealPopup('.radio-popup', 300)
  })
}

export default radioPopup();



// WEBPACK FOOTER //
// ../markup/assets/js/radio-popup.js